export default {"src":"/_next/static/media/prev_track.b648cf71.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};